import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueueBatch, QueueBatchDetailed } from '../interfaces/queue-batch.interface';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class QueueBatchService {
	readonly url: string = 'queueBatch';

	constructor(private http: HttpClient) {}

	public getQueueBatchByQueueId(queueId: number): Observable<QueueBatchDetailed[]> {
		return this.http.get<QueueBatchDetailed[]>(`${this.url}/getQueueBatchByQueueId/${queueId}`);
	}
}
